import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

export interface Payroll {
    activitiesCapture: number;
    createdAt: any;
    finalDay: string;
    multiplicationFactor: number;
    paymentPeriod: string;
    paymentPerPerson: number;
    paymentPerPersonF: number;
    cfCommission: number;
    startDay: string;
    tableQuantity: number;
    updatedAt: any;
    maxDaysLoad: number;
    entryTime: string;
    businessDays: boolean[];
    bonus: number;

    folios: Folios;
    defaults: Defaults;
    isoDescriptions: IsoDescriptions;
    specialRoles: SpecialRoles;
}

export interface PayrollId extends Payroll {
    id: string;
}

export interface Folios {
    customerBill: number;
    //customerBillRequesteds: Folios['customerBill'][];
    purchaseRequest: number;
    //purchaseRequestRequesteds: Folios['purchaseRequest'][];
    remission: number;
    //remissionRequesteds: Folios['remission'][];

    purchaseOrder: number;
    //purchaseOrderRequesteds: Folios['purchaseOrder'][];
    income: number;
    //incomeRequesteds: Folios['income'][];
    nextIn: number;
    //nextInRequesteds: Folios['nextIn'][];
    nextOut: number;
    //nextOutRequesteds: Folios['nextOut'][];

    billCreditNote: number;
    //suaje: number;
    address: number;
}
interface Defaults {
    iva: number;
    utilityQuot: number;
    fixedQuot: number;
    commissionQuot: number;
    mermaQuot: number;
    isrRetention: number;
    ivaRetention: number;
}
interface IsoDescriptions{
    COT: string; // Cotización
    OdP: string; // Orden de Producción
    Rem: string; // Remisión
    CrtCal: string; // Certificado de Calidad
    FichT: string; // Ficha Técnica
    EspT: string; // Especificación Técnica
    IntCmp: string; // Formato Interno de compras
    OdC: string; // Orden de Compra
    EnMq: string; // Entrada a Maquila
    Etiq: string; // Etiqueta

}
export interface SpecialRoles{
    qualityInspector: string;
}

@Injectable()
export class CatalogsSettingsService {

    // Attributes for the Payroll settings
    payrollSettingsCollection: AngularFirestoreCollection<Payroll>;
    payrollSettingsDocument: AngularFirestoreDocument<PayrollId>;
    payrollSettings: Observable<PayrollId>;

    collection: string;

    constructor(
        private afs: AngularFirestore,
        private fsService: FirestoreService,
    ) {
        this.collection = Globals.CATALOGS_SETTINGS;
    }

    // Method to create the Payroll settings
    /*postPayrollSettingsWithId(payrollObject: any, id$: string) {
        this.payrollSettingsCollection = this.afs.collection(this.collection);

        return this.payrollSettingsCollection.doc(id$).set(payrollObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }*/

    // Method to get the Payroll settings
    // 1 : Por horario
    // 2 : Por turno
    getPayrollSettings(id$: string) {
        this.payrollSettingsDocument = this.afs.doc(this.collection + '/' + id$);

        this.payrollSettings = this.payrollSettingsDocument.valueChanges();

        return this.payrollSettings.map(object => object);
    }

    // Method to update the Payroll settings
    putPayrollSettings(payrollObject: any, id$: string) {
        this.payrollSettingsCollection = this.afs.collection(this.collection);

        return this.payrollSettingsCollection.doc(id$).update(payrollObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }


    async getNextFolioAndIncrement(key: keyof Folios): Promise<number> {
        let folios: Folios = await this.fsService.docWithId(`${Globals.CATALOGS_SETTINGS}/folios`) as Folios;
        let nextFolio: number = folios[key] || 0;
        await this.fsService.update(`${Globals.CATALOGS_SETTINGS}/folios`, { [key]: nextFolio + 1 });
        return nextFolio;
    }

}
